import { UserModule } from '@/store/modules/user';

/**
 * CheckPermission 鉴权
 * @param { string[] } value
 */
const checkPermission = (value: string[]): boolean => {
  const roles = UserModule.resourceKeys || [];
  if (value && value instanceof Array && value.length > 0) {
    return roles.some((role) => value.includes(role));
  } else {
    throw new Error(`无效规则! 请按照 ['roles'...]`);
  }
}

export default checkPermission;
